import React, { Suspense } from 'react'
import { Spinner } from '../components/Spinner'

// Helper for lazy loading
export const load = (Component: any) => (props: any) => (
  <Suspense fallback={<Spinner />}>
    <Component {...props} />
  </Suspense>
)
